import { SVGProps } from 'react'

export const EmojiEventNotify = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <rect width="16" height="16" fill="#3A79E0" rx="4"></rect>
    <path
      fill="#fff"
      d="M11.5 4.5h-1V4c0-.275-.225-.5-.5-.5H6c-.275 0-.5.225-.5.5v.5h-1c-.55 0-1 .45-1 1V6c0 1.275.96 2.315 2.195 2.47.315.75.99 1.315 1.805 1.48v1.55H6c-.275 0-.5.225-.5.5s.225.5.5.5h4c.275 0 .5-.225.5-.5s-.225-.5-.5-.5H8.5V9.95a2.505 2.505 0 001.805-1.48A2.496 2.496 0 0012.5 6v-.5c0-.55-.45-1-1-1zM4.5 6v-.5h1v1.91c-.58-.21-1-.76-1-1.41zm7 0c0 .65-.42 1.2-1 1.41V5.5h1V6z"
    ></path>
  </svg>
)
